import { render } from "./YouTubeVideo.vue?vue&type=template&id=38f85264"
import script from "./YouTubeVideo.vue?vue&type=script&lang=ts"
export * from "./YouTubeVideo.vue?vue&type=script&lang=ts"

import "./YouTubeVideo.vue?vue&type=style&index=0&id=38f85264&lang=stylus"
script.render = render

export default script